<!-- Modal -->
<div class="modal fade" id="kt_modal_port_add_edit" tabindex="-1" aria-hidden="true">
  <!-- Modal dialog -->
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <!-- Modal content -->
    <div class="modal-content">
      <!-- Modal header -->
      <div class="modal-header" id="kt_modal_port_add_edit_header">
        <!-- Modal title -->
        <h2 class="fw-bold">{{ isEditMode ? 'Edit Port' : 'Add Port' }}</h2>
        <!-- Close -->
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-kt-users-modal-action="close" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>
      <!-- Modal body -->
      <div class="modal-body px-5 my-7">
        <!-- Form -->
        <form [formGroup]="portForm" (ngSubmit)="onSubmit()" id="kt_modal_port_add_edit_form" class="form">
          <!-- Port Name -->
          <div class="fv-row mb-7">
            <label class="required fw-semibold fs-6 mb-2">Port Name</label>
            <input
              type="text"
              formControlName="name"
              class="form-control form-control-solid mb-3 mb-lg-0"
              placeholder="Enter port name"
              [class.is-invalid]="name?.invalid && name?.touched" />
            <div *ngIf="name?.invalid && name?.touched" class="invalid-feedback">
              <div *ngIf="name?.errors?.['required']">Port name is required</div>
              <div *ngIf="name?.errors?.['minlength']">Port name must be at least 2 characters</div>
            </div>
          </div>

          <!-- Parent Country -->
          <div class="fv-row mb-7">
            <label class="required fw-semibold fs-6 mb-2">Parent Country</label>
            <select
              formControlName="country_code"
              class="form-select form-select-solid"
              [class.is-invalid]="country_code?.invalid && country_code?.touched">
              <option value="">Select a country</option>
              <option *ngFor="let country of countryList" [value]="country.code">
                {{ country.name }}
              </option>
            </select>
            <div *ngIf="country_code?.invalid && country_code?.touched" class="invalid-feedback">
              <div *ngIf="country_code?.errors?.['required']">Parent country is required</div>
            </div>
          </div>

          <!-- Actions -->
          <div class="text-center pt-10">
            <button
              type="reset"
              class="btn btn-light me-3"
              data-bs-dismiss="modal"
              [disabled]="isLoading">
              Discard
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              [disabled]="isLoading">
              <span *ngIf="!isLoading" class="indicator-label">
                {{ isEditMode ? 'Update' : 'Submit' }}
              </span>
              <span *ngIf="isLoading" class="indicator-progress">
                Please wait...
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
